import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import SideNav from "./sideNav";
import Dashboard from "../Dashboard";
import Processes from "../Processes";
import Schedules from "../Schedules";
import Workers from "../Workers";
import Vault from "../Vault";
import Queues from "../Queues";
// import Eworkers from "../Eworkers";
// import ConversationFlows from "../ConversationFlows";
// import DocumentFlows from "../DocumentFlows";
import "./index.css";

function UserHomePage(props) {    
  return (
    <div className="user-home-container">
      <SideNav {...props} />
      <div className="right-content">
        <Switch>
          {/* <Route path="/eworkers" component={Eworkers} />
          <Route path="/conversations" component={ConversationFlows} />
          <Route path="/documents" component={DocumentFlows} /> */}
          <Route path="/dashboard" component={Dashboard} />
          <Route path="/processes" component={Processes} />
          <Route path="/schedules" component={Schedules} />
          <Route path="/workers" component={Workers} />
          <Route path="/vault" component={Vault} />
          <Route path="/queues" component={Queues} />
          <Redirect from="/" to="/dashboard" />
        </Switch>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
  organizations: state.organizations,
});

export default connect(mapStateToProps, null)(UserHomePage);
